export default {"src":"/_next/static/media/lk-close-eye.0191f3be.svg","height":32,"width":32};